<div [formGroup]="editForm" class="form">
  <div
    *ngFor="let field of formFields"
    id="{{ field.name }}"
    [ngClass]="
      field.displayType == 'multiSelect' || field.displayType == 'select'
        ? 'fieldMulti'
        : 'field'
    "
  >
    <ng-container *ngIf="field.displayType == 'select'">
      <ng-container *ngIf="field.showField">
        <!-- For SELECT type of fields (single)-->
        <mat-form-field appearance="outline" style="width: 95%">
          <mat-select
            [formControlName]="field.name"
            [id]="field.id"
            placeholder="Please select an option"
            floatPlaceholder="never"
            required="true"
            (selectionChange)="
              modifyConfigValues($event, field.name); exportForm(editForm)
            "
          >
            <mat-option
              *ngFor="let item of field.options.data"
              [value]="item.value"
              [disabled]="item.disabled"
            >
              {{ item.text }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!-- end SELECT-->
      </ng-container>
    </ng-container>

    <ng-container *ngIf="field.displayType == 'multiSelect'">
      <ng-container *ngIf="field.showField">
        <!-- For SELECT type of fields (multiple)-->
        <ng-select
          [items]="field.options.data"
          class="custom"
          [appendTo]="'body'"
          [formControlName]="field.name"
          [closeOnSelect]="false"
          placeholder="Please select an option"
          floatPlaceholder="never"
          required="true"
          [multiple]="true"
          (selectionChange)="
            modifyConfigValues($event, field.name); exportForm(editForm)
          "
          bindLabel="text"
          bindValue="value"
          [hideSelected]="true"
        >
        </ng-select>
        <!-- end SELECT-->
      </ng-container>
    </ng-container>

    <ng-container
      *ngIf="field.displayType == 'text' || field.displayType == 'number'"
    >
      <ng-container *ngIf="field.showField">
        <!-- For TEXT & NUMBER type of fields-->
        <mat-form-field appearance="outline" style="width: 95%">
          <input
            matInput
            [formControlName]="field.name"
            name="{{ field.name }}"
            placeholder="{{ field.placeholder || 'Enter a Value' }}"
            type="{{ field.displayType }}"
            required="true"
            (change)="exportForm(editForm)"
          />
        </mat-form-field>
        <!-- end TEXT & NUMBER -->
      </ng-container>
    </ng-container>

    <ng-container *ngIf="field.displayType == 'textarea'">
      <ng-container *ngIf="field.showField">
        <!-- For TEXTFIELD type of fields-->
        <mat-form-field appearance="outline" style="width: 95%">
          <textarea
            matInput
            [formControlName]="field.name"
            name="{{ field.name }}"
            placeholder="{{ field.title }}"
            type="{{ field.displayType }}"
            required="true"
            (change)="exportForm(editForm)"
          ></textarea>
        </mat-form-field>
        <!-- end TEXTFIELD-->
      </ng-container>
    </ng-container>

    <ng-container *ngIf="field.displayType == 'datepicker'">
      <ng-container *ngIf="field.showField">
        <!-- For DATE (text) type of fields-->
        <mat-form-field appearance="outline" style="width: 95%" class="date">
          <input
            matInput
            readonly
            [matDatepicker]="picker"
            (click)="picker.open()"
            (dateChange)="exportForm(editForm)"
            [formControlName]="field.name"
            name="{{ field.name }}"
            required="true"
            placeholder="Select a Date"
          />
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
        <!-- end DATE-->
      </ng-container>
    </ng-container>

    <ng-container *ngIf="field.displayType == 'daterange'" class="date">
      <ng-container *ngIf="field.showField">
        <!-- For DATERANGE  type of fields-->
        <mat-form-field appearance="outline" style="width: 95%">
          <mat-date-range-input
            [formGroupName]="field.name"
            [rangePicker]="picker"
            required="true"
          >
            <input
              matStartDate
              formControlName="start"
              placeholder="Start date"
              required="true"
            />
            <input
              matEndDate
              formControlName="end"
              placeholder="End date"
              [required]="field.isRequired"
            />
          </mat-date-range-input>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
        <!-- end DATERANGE -->
      </ng-container>
    </ng-container>

    <ng-container
      *ngIf="
        field.displayType == 'button-toggle' ||
        field.displayType == 'toggle' ||
        field.displayType == 'checkbox'
      "
      appearance="legacy"
    >
      <ng-container *ngIf="field.showField">
        <!-- For TOGGLE type of fields-->
        <div
          [formGroupName]="field.name"
          style="width: 95%; display: inline-block; margin-right: 5px"
          class="requiredToggle"
        >
          <mat-button-toggle-group
            #group="matButtonToggleGroup"
            [multiple]="field.multiple"
            formControlName="item"
            required="true"
          >
            <mat-button-toggle
              *ngFor="let toggle of field.options.data"
              mat-raised-button
              [value]="toggle.value"
              >{{ toggle.text }}</mat-button-toggle
            >
          </mat-button-toggle-group>
        </div>
        <!-- end TOGGLE-->
      </ng-container>
    </ng-container>
  </div>
</div>
